export default __webpack_public_path__ + "static/media/hero-dog.52d7d0ea.jpg";